import React from 'react';
import { Container, Typography, Box, Card, CardContent } from '@mui/material';
import { Assignment } from '@mui/icons-material';

const MyPatientsPage: React.FC = () => {
  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Box display="flex" alignItems="center" mb={4}>
        <Assignment sx={{ mr: 2, fontSize: 32, color: 'primary.main' }} />
        <Typography variant="h4" component="h1">
          My Patients
        </Typography>
      </Box>

      <Card>
        <CardContent>
          <Typography variant="h6" gutterBottom>
            Patient Management
          </Typography>
          <Typography variant="body1" color="text.secondary">
            This page will help you manage your patient relationships, care plans, and communication.
          </Typography>
          
          <Box mt={3}>
            <Typography variant="subtitle1" gutterBottom>
              Coming Soon:
            </Typography>
            <ul>
              <li>Patient list and profiles</li>
              <li>Care plan management</li>
              <li>Appointment scheduling</li>
              <li>Progress notes and updates</li>
              <li>Communication with patients</li>
            </ul>
          </Box>
        </CardContent>
      </Card>
    </Container>
  );
};

export default MyPatientsPage;
